module.exports = __webpack_public_path__ + "img/sortImg1-6.52df9e06.png";